import React, { useMemo } from "react";
import "./style.scss";
import BaseLayout from "../../../components/Layout";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  actionGetAlertasProperty,
  updateAlertasPropertyData,
} from "../../../features/alertas/getAll-alertas/slices";
import conectSocket from "../../../helpers/connect-socket";
import { actionGetPontosMonitoriaByLoja } from "../../../features/monitoramento/lista-pontos/slices";
import { actionGetPontosMonitoriaGeral } from "../../../features/getPontosMonitoramentoPorCliente/slices";
import { usePainelPublico } from "../../../hooks/usePainelPublico";
import connectSocket from "../../../helpers/connect-socket";
import { LoaderCircle } from "lucide-react";


const IconImportanciaSegurada = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const IconSetores = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);
const IconRiscos = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const IconOcorrencias = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const IconCaixaFerramentas = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

const IconPontosMonitoria = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const MetricCard = ({
  icon,
  title,
  value,
  isLargeValue = false,
  className = "",
}: any) => (
  <div className={`metricCard ${className}`}>
    <div className="iconWrapper">{icon}</div>
    <div className="textWrapper">
      <p className="metricTitle" title={title}>
        {title}
      </p>
      <p className={`metricValue`}>{value}</p>
    </div>
  </div>
);


const PagePropertyApiKey = () => {
  const dispatch = useAppDispatch();
  const { apiKey, status: status2, data } = usePainelPublico();

  console.log("API Key:", apiKey);
  console.log("API Key Status:", status2);
  console.log("Configurações recebidas:", data);

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const lojas = useAppSelector((state) => state.getLojas.lojas);

  const idRegionalUser = 1;
  const idCliente = data?.idCliente as number;

  console.log("Loja selecionada (ID):", lojaSelected);
  console.log("Lojas disponíveis:", lojas);
  console.log("user:", 1);
  console.log("ID Cliente do usuário:", idCliente);

  const currentIdLoja = lojaSelected ? Number(lojaSelected) : 0;

  const { data: metrics, status } = useAppSelector(
    (state) => state.getAlertasProperty,
  );

  const pontosMonitoriaByLoja = useAppSelector(
    (state) => state.pontosMonitoriaByLoja,
  );
  const pontosMonitoriaGeral = useAppSelector(
    (state) => state.getPontosMonitoriaGeral,
  );

  const loading = status === "loading";

  const totalPontosMonitoria = useMemo(() => {
    const dataSource =
      currentIdLoja > 0 ? pontosMonitoriaByLoja : pontosMonitoriaGeral;

    const grupos = dataSource?.data?.grupoMonitor;

    if (!grupos || !Array.isArray(grupos)) return 0;

    return grupos.reduce((acc: number, grupo: any) => {
      const qtdA = grupo.listaMonA?.length || 0;
      const qtdD = grupo.listaMonD?.length || 0;
      const qtdR = grupo.listaMonR?.length || 0;
      return acc + qtdA + qtdD + qtdR;
    }, 0);
  }, [pontosMonitoriaByLoja, pontosMonitoriaGeral, currentIdLoja]);

  const loadingPontos =
    currentIdLoja > 0
      ? pontosMonitoriaByLoja.status === "loading"
      : pontosMonitoriaGeral.status === "loading";

  const handleSocketUpdate = React.useCallback(
    (data: any) => {
      dispatch(updateAlertasPropertyData(data));
    },
    [dispatch],
  );

  React.useEffect(() => {
    let connection: any = null;

    if (idRegionalUser && idCliente) {
      console.log(`Buscando alertas para o cliente ${idCliente}...`);
      dispatch(
        actionGetAlertasProperty({
          idLoja: 0,
          idCliente: idCliente,
          apiKey,
        }),
      );

      if (currentIdLoja > 0) {
        console.log(
          `Buscando pontos de monitoria para a loja ${currentIdLoja}...`,
        );
        dispatch(actionGetPontosMonitoriaByLoja(currentIdLoja, apiKey));
      } else {
        console.log(
          `Buscando pontos de monitoria geral para o cliente ${idCliente}...`,
        );
        dispatch(actionGetPontosMonitoriaGeral(apiKey));
      }

      connection = connectSocket({
        url: "hubProperty",
        hub: "PropertyDados",
        cb: handleSocketUpdate,
        apiKey: apiKey,
        params: { idLoja: currentIdLoja },
      });
    }

    return () => {
      if (connection) {
        console.log(`Desconectando socket...`);
        connection.stop();
      }
    };
  }, [
    currentIdLoja,
    handleSocketUpdate,
    idRegionalUser,
    idCliente,
    dispatch,
    apiKey,
  ]);

  console.log("Logos: ", data?.logos);

  return (
    <div className="pageContainer">
      {/*<div style={{ marginBottom: "1rem" }}>*/}
      {/*  <h1 style={{ fontSize: "1.6rem", color: "#555" }}>*/}
      {/*    {currentIdLoja === 0*/}
      {/*      ? "Visão Geral - Todas as Lojas"*/}
      {/*      : `Loja: ${*/}
      {/*          lojas.find((l) => l.id === currentIdLoja)?.nome ||*/}
      {/*          currentIdLoja*/}
      {/*        }`}*/}
      {/*  </h1>*/}
      {/*</div>*/}

      <div className="logos">
        {data &&
          data.logos.map((logoUrl: string, index: number) => (
            <img
              className="logo"
              key={index}
              src={logoUrl}
              alt={`Logo ${index + 1}`}
            />
          ))}
      </div>

      <div className="metricsGrid">
        <MetricCard
          icon={<IconImportanciaSegurada />}
          title="Importância Segurada"
          value={(metrics.importanciaSegurada || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}
          isLargeValue
        />

        <MetricCard
          icon={<IconRiscos />}
          title="Clientes Monitorados"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.quantidadeClientes
            )
          }
        />

        <MetricCard
          icon={<IconSetores />}
          title="Lojas Monitoradas"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.quantidadeLojas
            )
          }
        />

        <MetricCard
          icon={<IconPontosMonitoria />}
          title="Pontos de Monitoramento"
          value={
            loadingPontos ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              totalPontosMonitoria
            )
          }
        />

        <MetricCard
          icon={<IconCaixaFerramentas />}
          title="Para Tratamento"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.paraTratamento
            )
          }
        />

        <MetricCard
          icon={<IconCaixaFerramentas />}
          title="Tratadas (30 Dias)"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.tratadas30d
            )
          }
        />

        <MetricCard
          icon={<IconCaixaFerramentas />}
          title="CENTRAIS"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.quantidadeCentrais
            )
          }
        />

        <MetricCard
          icon={<IconCaixaFerramentas />}
          title="Tratadas (90 Dias)"
          value={
            loading ? (
              <LoaderCircle className="loader"></LoaderCircle>
            ) : (
              metrics.tratadas90d
            )
          }
        />
      </div>
    </div>
  );
};

export default PagePropertyApiKey;
